// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';

// 用户管理
import User from '@/views/user/User';
import onLine from '@/views/user/onLine';
// 用户管理
import Feedback from '@/views/user/Feedback';




// 管理员管理
import Admin from '@/views/system/Admin';

// 技能审核
import Goods from '@/views/goods/Goods';
// 商品分类
import Classify from '@/views/goods/Classify';
// 交易订单
import Order from '@/views/pay/Order';
// 数据大屏
import Screen from '@/views/dashboard/Screen';

// 财务明细
import Finance from '@/views/finance/Finance';
// 提现管理
import Withdraw from '@/views/finance/Withdraw';
// 押金管理
import Deposit from '@/views/finance/Deposit';

// 轮播图管理
import Carousel from '@/views/terrace/Carousel';

// 协议管理
import Agreement from '@/views/terrace/Agreement';

// 资讯分类管理
import NewsClassify from '@/views/terrace/NewsClassify';
// 资讯分类管理二级
import NewsClassifyTwo from '@/views/terrace/NewsClassifyTwo';

import Valuation from '@/views/terrace/Valuation';





// 启用路由
Vue.use(Router);

// 导出路由 
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [{
            path: '/dashboard/Screen',
            name: '数据看板',
            component: Screen,
            meta: {
                requireAuth: true
            }
        },{
            path: '/User/User',
            name: '用户管理',
            component: User,
            meta: {
                requireAuth: true
            }
        },{
            path: '/User/onLine',
            name: '在线用户管理',
            component: onLine,
            meta: {
                requireAuth: true
            }
        },{
            path: '/User/Feedback',
            name: '用户投诉',
            component: Feedback,
            meta: {
                requireAuth: true
            }
        },{
            path: '/goods/Goods',
            name: '技能审核',
            component: Goods,
            meta: {
                requireAuth: true
            }
        },{
            path: '/goods/Classify',
            name: '商品分类',
            component: Classify,
            meta: {
                requireAuth: true
            }
        },{
            path: '/pay/Order',
            name: '交易订单',
            component: Order,
            meta: {
                requireAuth: true
            }
        },{
            path: '/finance/Finance',
            name: '财务明细',
            component: Finance,
            meta: {
                requireAuth: true
            }
        },{
            path: '/finance/Withdraw',
            name: '提现管理',
            component: Withdraw,
            meta: {
                requireAuth: true
            }
        },{
            path: '/finance/Deposit',
            name: '押金管理',
            component: Deposit,
            meta: {
                requireAuth: true
            }
        },{
            path: '/terrace/Carousel',
            name: '轮播图管理',
            component: Carousel,
            meta: {
                requireAuth: true
            }
        },{
            path: '/terrace/Agreement',
            name: '协议管理',
            component: Agreement,
            meta: {
                requireAuth: true
            }
        },{
            path: '/terrace/NewsClassify',
            name: '分类管理',
            component: NewsClassify,
            meta: {
                requireAuth: true
            }
        },{
            path: '/terrace/NewsClassifyTwo',
            name: '分类管理二级',
            component: NewsClassifyTwo,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/terrace/Valuation',
            name: '基础设置',
            component: Valuation,
            meta: {
                requireAuth: true
            }
        },{
            path: '/system/Admin',
            name: '管理员管理',
            component: Admin,
            meta: {
                requireAuth: true
            }
        }]
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js